import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CampusNewsEventsListComponent } from "./campus-news-events-list/campus-news-events-list.component";
import { CampusNewsEventsCreateComponent } from "./campus-news-events-create/campus-news-events-create.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "list-campus-news-events",
        component: CampusNewsEventsListComponent,
        data: {
          title: "List CampusNewsEvents",
          breadcrumb: "List CampusNewsEvents",
        },
      },
      {
        path: "create-campus-news-events",
        component: CampusNewsEventsCreateComponent,
        data: {
          title: "Create CampusNewsEvents",
          breadcrumb: "Create CampusNewsEvents",
        },
      },
      {
        path: "create-campus-news-events/:id",
        component: CampusNewsEventsCreateComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampusNewsEventsRoutingModule {}
